const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    if (rawData) {
      row["nomor_polisi"] = rawData.nomor_polisi;
      row["speedo_akhir"] = rawData.speedo_akhir;
      row["service_nama"] = rawData.service_nama;
      row["tanggal_terakhir_service"] = rawData.tanggal_terakhir_service;
      row["km_warning"] = rawData.km_warning;
      row["last"] = rawData.last;
      row["next"] = rawData.next;

      _list.push(row);
    }
  }
  return _list;
};

export default ReportTemplateReformatCopyData;
